// Define types for events and tickets
import { LocationType, SeatStatus } from './Location'
import { ShowWithImages } from './Show'

export interface EventType {
    event_id: string
    org_id: string
    show_id: string
    location_id: string
    custom_image?: string
    description?: string
    social_media_link?: string
    local_selling: boolean
    selling_start_date: string
    selling_end_date: string
    event_date: string
    tickets?: Ticket[]
    seat_selling_mode: SeatSellingMode
}

export type SeatSellingMode = 'seatbased' | 'general'

export const SeatSellingModes = {
    SeatBased: 'seatbased' as SeatSellingMode,
    General: 'general' as SeatSellingMode,
}
export interface Ticket {
    ticket_id: string
    event_id: string
    seat_id: string
    price: number
    status: SeatStatus
    is_complimentary?: boolean
    system_usage_fee?: number | null
    locked_by?: string | null // Session ID that locked the seat, or null if not locked
    locked_at?: Date | null // Timestamp of when the seat was locked, or null if not locked
    bought_by?: string | null // Transaction ID (OTP Simple) for purchase, or null if not bought
}

export interface CreateTicket {
    event_id?: string
    seat_id: string
    price: number
}

export interface EventDetails {
    tickets?: Ticket[]
    event_id: string
    org_id: string
    show_id: string
    location_id: string
    custom_image?: string | null
    description?: string
    social_media_link?: string
    local_selling: boolean
    selling_start_date: string
    selling_end_date: string
    event_date: string
    show: ShowWithImages
    location: LocationType
    seat_selling_mode: SeatSellingMode
    number_of_all_tickets: number
    number_of_sold_tickets: number
    number_of_arrived_tickets: number
}

export interface CreateEventDto {
    event: Omit<EventType, 'event_id' | 'org_id'>
    tickets: Omit<Ticket, 'ticket_id' | 'event_id'>[]
}

export interface UpdateEventDto {
    event: Partial<Omit<EventType, 'org_id'>>
    tickets: Omit<Ticket, 'ticket_id'>[]
}
